import WeaveUi from './weave-ui';

export default class AjaxLoader extends WeaveUi {

    constructor() {
        super();
        this.ajaxStart();
    }

    ajaxStart() {
        let ajaxLoadTimeout;
        $(document).ajaxStart(function() {
            ajaxLoadTimeout = setTimeout(function() {
                var $loader = $('.loader');
                $loader.css({
                    "position": "fixed",
                    "top": "50%",
                    "left": "50%",
                    "margin-top": "-" + ($loader.height() / 2) + "px",
                    "margin-left": "-" + ($loader.outerWidth() / 2) + "px"
                });
                $('.loader-container').removeClass('disabled');
            }, 1000);
        }).ajaxStop(function() {
            clearTimeout(ajaxLoadTimeout);
            $('.loader-container').addClass('disabled');
        });
    }

};


// WEBPACK FOOTER //
// ./js/weave-ui/ajax-loader.js